import { useMemo } from "react";

import type { BackendApi } from "../../backend/index.ts";
import { createRedeliverUnsentServerActions } from "./redeliverUnsentServerActions.ts";

export const useRedeliverUnsentServerActions = ({ api, hostId }: { api: BackendApi; hostId: string }) =>
  useMemo(() => createRedeliverUnsentServerActions({ api, hostId }), [api, hostId]);
